import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Typo, Icon, Button, SubPage } from '../../../ui';
import { useSettings } from '../../settings/hooks/useSettingsState';
import { useSettingsActions } from '../../settings/hooks/useSettingsActions';
import { CONTENT_SMALL } from '../../../utils/media';
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, List, ListItem, ListItemButton, ListItemIcon } from '@mui/material';

const ProfileNotifications = () => {
  const { t } = useTranslation();
  const { settings } = useSettings();
  const { updateSettings } = useSettingsActions();
  const [checked, setChecked] = useState();

  const notificationLabels = React.useMemo(() => ({
    1: t('profile.notification_types.addedToGroup'),
    2: t('profile.notification_types.taskFeedback'),
    3: t('profile.notification_types.postAdded'),
    4: t('profile.notification_types.taskAssessed'),
    5: t('profile.notification_types.youAreMentioned'),
    6: t('profile.notification_types.feedbackRequired'),
    7: t('profile.notification_types.unreviewedTask'),
    8: t('profile.notification_types.threadNewPost'),
    9: t('profile.notification_types.courseNewPost'),
    10: t('profile.notification_types.courseSold'),
    11: t('profile.notification_types.coursePackageSold'),
    12: t('profile.notification_types.addedToCourse'),
    // 13: t('profile.notification_types.weMissYou'),
    14: t('profile.notification_types.dripContent'),
    15: t('profile.notification_types.dataExport'),
    16: t('profile.notification_types.courseInvite'),
    17: t('profile.notification_types.customMessages'),
  }), [t]);


  useEffect(() => {
    const newChecked = [];
    for (const property in settings.notifications) {
      if (settings.notifications[property] === 1) newChecked.push(property);
    }
    setChecked(newChecked);
  }, [settings])

  const handleToggle = useCallback((value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) newChecked.push(value);
    else newChecked.splice(currentIndex, 1);

    setChecked(newChecked);
  }, [checked]);

  const ToggleEmailNotifications = useCallback(async (event) => {
    event.stopPropagation();
    const settingsData = {
      sendBulletin: !settings.sendBulletin
    }

    await updateSettings(settingsData);
  }, [updateSettings, settings]);

  const saveNotifications = useCallback(async () => {
    const notificationsTmp = { ...settings.notifications };

    for (let key in notificationsTmp) {
      notificationsTmp[key] = false;
    }
    checked.map(id => {
      return notificationsTmp[id] = 1;
    });
    const settingsData = {
      notifications: notificationsTmp
    }

    await updateSettings(settingsData);
  }, [updateSettings, checked, settings])

  return (
    <SubPage size={CONTENT_SMALL} align='flex-start' gap='20' >
      <Typo.ContentSmallHeader $textAlign='left' >{t('profile.manageNotifications')}</Typo.ContentSmallHeader>
      <Typo.MediumText>{t('profile.manageNotifications_disclaimer')}</Typo.MediumText>
      <div>
        <Accordion>
          <AccordionSummary >
            <Flex gap='20' width='100%' justify='space-between'>
              <Flex gap='10' direction='column' align='flex-start'>
                <Typo.TextTitle>{t('profile.emailNotifications')}</Typo.TextTitle>
                <Typo.MediumText>{t('profile.emailNotifications_description')}</Typo.MediumText>
              </Flex>
              <Button onClick={ToggleEmailNotifications}>{settings.sendBulletin ? t('profile.turnOffEmailReminders') : t('profile.turnOnEmailReminders')}</Button>
            </Flex>
          </AccordionSummary>
          <AccordionDetails>
            <Typo.MediumText>{t('profile.emailNotifications_details')}</Typo.MediumText>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<Icon.ExpandMore />}>
            <Flex gap='10' direction='column' align='flex-start' >
              <Typo.TextTitle>{t('profile.inAppNotifications')}</Typo.TextTitle>
              <Typo.MediumText>{t('profile.inAppNotifications_description')}</Typo.MediumText>
            </Flex>
          </AccordionSummary>
          <AccordionDetails>
            <List sx={{ width: '100%', maxWidth: 360 }}>
              {settings.notifications && Object.keys(settings.notifications).map((id) => {
                const labelId = `checkbox-list-label-${id}`;
                const label = notificationLabels[id];
                if (!label) return null;
                return (
                  <ListItem
                    key={id}
                    disablePadding
                  >
                    <ListItemButton role={undefined} onClick={handleToggle(id)} dense>
                      <ListItemIcon>
                        <Checkbox
                          edge="start"
                          checked={checked?.indexOf(id) !== -1}
                          tabIndex={-1}
                          disableRipple
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </ListItemIcon>
                      <Typo.Text>{label}</Typo.Text>
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
            <Flex justify='flex-end'>
              <Button onClick={saveNotifications}>{t('globals.save')}</Button>
            </Flex>
          </AccordionDetails>
        </Accordion>
      </div>
    </SubPage >
  );
};

export default ProfileNotifications;
